/* eslint-disable */ import { detailComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const bottomWallApplianceComponents = [
    attachComponent.withComponent(detailComponent, 'default', true).withAlias('BottomWallAppliance').attach(memoEval((self)=>[
            self.$name,
            self.$sku,
            self.$description,
            self.$thumbnailUrl
        ], ($name, $sku, $description, $thumbnailUrl)=>({
            title: $name,
            subtitle: $sku,
            description: $description,
            thumbnailUrl: $thumbnailUrl
        })))
];

//# sourceMappingURL=bottom-wall-appliance.js.map